import { render, staticRenderFns } from "./CreateOrEditSale.vue?vue&type=template&id=4cdb5e73&scoped=true&"
import script from "./CreateOrEditSale.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditSale.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditSale.vue?vue&type=style&index=0&id=4cdb5e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb5e73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperHeader,VStepperItems,VStepperStep})
